import { IonButton, IonPage, useIonAlert } from "@ionic/react";
import { downloadFile } from "../../services/genericMethoud/generice";
import docsReportmage from "../../images/docsReportmage.jpg";
import LightGalleryComponent from "../../components/molecules/LightGalleryComponent";
import "./docsReportModel.css";

const DocsReportModel = ({
  docsReportModelDismiss,
}: {
  userId: any,
  IsReport: any,
  IsLogoMessage: any
  docsReportModelDismiss: (data?: string | null | undefined | number, role?: string) => void;
}) => {
  const [presentAlert] = useIonAlert();
  const handleDownload = async () => {
    try {
      // Fetch the image and convert to blob
      const response = await fetch(docsReportmage);
      if (!response.ok) {
        throw new Error('Failed to fetch image');
      }
      
      const blob = await response.blob();
      
      // Use the generic downloadFile function
      const success = await downloadFile(blob, 'دليل_المستخدم_User_Guide.jpg');
      
      if (!success) {
        throw new Error('Download failed');
      }
      
    } catch (error) {
      console.error('Download error:', error);

      presentAlert({
        cssClass: "",
        header: "تنبية",
        message: `<strong class="strongStyle">هل تريد الحذف ؟.. الملف سيتم حذفة نهائيأ </strong >`,
        buttons: [
          {
            text: "موافق",
          }
        ]
      });

    }
  };

  return (
    <IonPage>
      <div className="docsReportWrapper">
        <div className="w-full flex flex-col justify-start items-center py-4 px-6">
          <div className="w-full flex flex-col justify-start items-center">
            <div className="w-full flex flex-row justify-between items-center">

              <div className="flex flex-col justify-center items-center w-full my-4">
                <p className="font-bold text-primaryColor100 text-2xl">
                  دليل المستخدم
                </p>
              </div>
              <div className="flex gap-2">
                <IonButton
                  fill="solid"
                  onClick={handleDownload}
                  className="text-green-500"
                  color="success"
                  style={{
                    backgroundColor: '#22c55e',
                    border: '2px solid #16a34a',
                    borderRadius: '8px'
                  }}
                >
                  تحميل
                </IonButton>
                <IonButton
                  fill="solid"
                  onClick={() => docsReportModelDismiss()}
                  className="text-danger-500"
                  color="danger"
                  style={{
                    backgroundColor: '#ef4444',
                    border: '2px solid #dc2626',
                    borderRadius: '8px'
                  }}
                >
                  إغلاق
                </IonButton>
              </div>

            </div>
            <div className="w-full flex justify-center items-center mt-4">
              <LightGalleryComponent
                items={[{
                  file: docsReportmage,
                  isImage: true,
                  name: "دليل المستخدم"
                }]}
                itemClassName=""
                imageClassName="rounded w-full max-w-4xl h-auto object-contain shadow-lg animate__animated animate__flipInX"
              />
            </div>
          </div>
        </div>
      </div>
    </IonPage>
  );
};

export default DocsReportModel;
